var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.countries,"label":"Countries","multiple":"","chips":"","clearable":"","append-icon":"mdi-chevron-down"},on:{"change":_vm.updateValue},model:{value:(_vm.selectedCountries),callback:function ($$v) {_vm.selectedCountries=$$v},expression:"selectedCountries"}})
}
var staticRenderFns = []

export { render, staticRenderFns }